import ImageOptimizer from '@/components/image-optimizer';
import { slugify } from '@/lib/utils';
import { NearStoreEntity } from '@/services/types/license-test-course.type';
import { StoreType } from '@/services/types/store.type';
import Link from 'next/link';

type NearBranchCardProps = NearStoreEntity & {
  /** 거리 기준 장소 — '시험장에서 1.2km' */
  distanceFrom?: string;
  /** 지점 상세 링크에 붙일 쿼리(예: 'from=academy') */
  query?: string;
};

const NearBranchCard = ({
  distanceFrom = '시험장',
  query,
  ...nearStore
}: NearBranchCardProps) => {
  const branchSlug = slugify(nearStore.name, nearStore.id);
  return (
    <Link
      href={`/branch/${branchSlug}${query ? `?${query}` : ''}`}
      className="block w-full overflow-hidden transition"
    >
      {/* 1. 이미지 */}
      <div className="desktop:aspect-[372/219] relative aspect-[452/260] w-full overflow-hidden rounded-lg">
        <ImageOptimizer
          src={nearStore.photoPath ?? ''}
          alt={nearStore.name + ' 썸네일'}
          fill
          className="object-cover"
        />
        {nearStore.summaryAddress && nearStore.summaryAddress.length > 0 && (
          <>
            <span className="bg-sub-white/75 text-level-2 typo-16 absolute bottom-4 left-1/2 flex max-w-full -translate-x-1/2 justify-center overflow-hidden rounded-full border border-white px-3 py-2 font-bold text-ellipsis whitespace-nowrap">
              <div className="relative size-4 h-auto flex-shrink-0">
                <ImageOptimizer
                  src="/images/icons/icon_map_pin.svg"
                  alt="위치"
                  fill
                />
              </div>
              <span className="truncate">{nearStore.summaryAddress}</span>
            </span>
          </>
        )}
      </div>

      {/* 2. 정보 섹션 */}
      <div className="desktop:pt-5 pt-4 text-left">
        <div className="desktop:mb-3 mb-2.5 flex items-center">
          <h3 className="typo-20 text-level-1 desktop:typo-24 truncate font-extrabold">
            {nearStore.name}
          </h3>
          {nearStore?.type === StoreType.DIRECT && (
            <span className="bg-main-yellow text-level-1 typo-14 ml-2 inline-block rounded-sm px-2 py-1 text-center leading-[15px] font-bold">
              직영점
            </span>
          )}
        </div>

        <div className="typo-16 text-level-4 desktop:typo-18 flex items-start font-bold">
          <ImageOptimizer
            src="/images/icons/icon_map_pin.svg"
            alt="위치"
            width={16}
            height={16}
            className="size-4 h-auto pt-0.5"
          />
          <p className="ml-1 leading-snug">{`${distanceFrom}에서 ${nearStore.distance}km`}</p>
        </div>
      </div>
    </Link>
  );
};

export default NearBranchCard;
